import React from 'react';
import { Admin, Resource, List, Datagrid, TextField, Create, SimpleForm, TextInput, FileInput, FileField, UrlField, NumberField, useRecordContext, CustomRoutes } from 'react-admin';
import { ThemeProvider } from '@mui/material/styles';
import { Route } from 'react-router-dom';
import  dataProvider  from './dataProvider';
import { authProvider } from './authProvider';
import { Layout } from './Layout';
import Dashboard  from './Dashboard';

// Import Material-UI icons for each resource
import SettingsIcon from '@mui/icons-material/Settings';
import SourceIcon from '@mui/icons-material/Source';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PeopleIcon from '@mui/icons-material/People';
import CampaignIcon from '@mui/icons-material/Campaign';
import TokenIcon from '@mui/icons-material/Token';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

// import { defaultTheme } from 'react-admin';
import { lightTheme, darkTheme } from './theme';
import CustomLoginPage from './CustomLoginPage';

import RecordGridView from './provisioning/Provisioning';
import CodeSnippet from './codeSnippet';

import { ProvenanceEdit, ProvenanceCreate } from './provenance/ProvenanceEdit';
import ProvenanceList from './provenance/ProvenanceList';
import ProvenanceUpload from './provenance/ProvenanceUpload';
import { ProvenanceShow } from './provenance/ProvenanceShow';
import { VerificationsList } from './verifications/verificationsList';
import { VerificationShow } from './verifications/verificationShow';
import { NFTList } from './nfts/nftList';

// Import Legal Components
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import CookieSettings from './CookieSettings';

// Marketing - Import from dedicated marketing module
import MarketingRouter from './marketing/components/MarketingRouter';

// const lightTheme = {
//   ...defaultTheme,
//   palette: {
//       mode: 'light',
//       primary: {
//           main: '#1976d2', // preferred primary color
//       },
//       secondary: {
//           main: '#dc004e', // preferred secondary color
//       },
//   },
// };

// const darkTheme = {
//   ...defaultTheme,
//   palette: {
//       mode: 'dark',
//       primary: {
//           main: '#90caf9', // preferred primary color for dark mode
//       },
//       secondary: {
//           main: '#f48fb1', // preferred secondary color for dark mode
//       },
//   },
// };


// 1. Provisioning
const TagList = props => (
  <List {...props}>
    <RecordGridView />
  </List>
);

const TagList0 = (props) => (
  <List {...props} title="View Predefined Tags" perPage={25}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="manufacturer" />
      <TextField source="model" />
      <TextField source="frequency" />
      <TextField source="protocol" />
      <TextField source="security" />
      <TextField source="tamper_detection" />
      <UrlField source="URL" />
    </Datagrid>
  </List>
);

const TagPersonalize = () => (
  <div>
    <h1>Personalize Tags</h1>
    <p>Interface for tag customization</p>
  </div>
);

// 2. Provenance

const VintageField = props => {
  const record = useRecordContext(props);
  if (!record) return null;
  return <span>{record.vintage}</span>;
};
const AlcoholField = props => {
  const record = useRecordContext(props);
  if (!record) return null;
  return <span>{record.alcohol.toFixed(1)}%</span>;
};

const ProvenanceDetails = () => (
  <div>
    <h1>View Provenance Details</h1>
    <p>CSV preview, stats</p>
  </div>
);

// 3. Verifications
const VerificationList = (props) => (
  <List {...props} title="View Verifications" perPage={25}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="productId" />
      <TextField source="timestamp" />
      <TextField source="UID" />
      <TextField source="PICC_Data" />
      <TextField source="is_tt_closed" />
      <TextField source="is_valid" />
    </Datagrid>
  </List>
);

const VerificationReports = () => (
  <div>
    <h1>Reports</h1>
    <p>Time-series charts of scans</p>
  </div>
);

// 4. Consumers
const ConsumerList = (props) => (
  <List {...props} title="List Consumers" perPage={25}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="email" />
      <TextField source="DOB" />
      <TextField source="gender" />
      <TextField source="country" />
      <TextField source="segment" />

    </Datagrid>
  </List>
);

const ConsumerDetails = () => (
  <div>
    <h1>Consumer Details</h1>
    <p>Individual user data</p>
  </div>
);


const CampaignExport = () => (
  <div>
    <h1>Export Campaign</h1>
    <p>Generate CSV</p>
  </div>
);

// 7. Integrations
const IntegrationList = () => {
  const jsSnippet = `
  // VerifyPro Verification Tag Snippet
  (function() {
    var vpTag = document.createElement('div');
    vpTag.id = 'vp-verification-result';
    
    function checkVerification(productId) {
      // Simulating an API call to verify the product
      fetch('https://api.example.com/verify/' + productId)
        .then(response => response.json())
        .then(data => {
          var result = data.verified ? 'Authentic' : 'Not Verified';
          var color = data.verified ? 'green' : 'red';
          
          vpTag.innerHTML = \`
            <div style="font-family: Arial, sans-serif; border: 2px solid \${color}; padding: 10px; max-width: 300px;">
              <h3 style="color: \${color}; margin: 0 0 10px;">VerifyPro Verification Result</h3>
              <p style="margin: 0;">Product ID: \${productId}</p>
              <p style="margin: 5px 0; font-weight: bold;">Status: <span style="color: \${color};">\${result}</span></p>
              <p style="margin: 5px 0; font-size: 0.8em;">Verified on: \${new Date().toLocaleString()}</p>
            </div>
          \`;
        })
        .catch(error => {
          vpTag.innerHTML = '<p style="color: red;">Error: Unable to verify product.</p>';
        });
    }
  
    // Replace 'YOUR_PRODUCT_ID' with the actual product ID
    checkVerification('YOUR_PRODUCT_ID');
    
    // Append the tag to the body or a specific element
    document.body.appendChild(vpTag);
  })();
  `;
console.log('Hello, world!');

return (
  <CodeSnippet code={jsSnippet} />
);
}

const IntegrationCreate = (props) => (
  <Create {...props} title="Add Integration">
    <SimpleForm>
      <TextInput source="name" />
      <TextInput source="type" />
      <TextInput source="webhookUrl" />
    </SimpleForm>
  </Create>
);

const VerificationPageSetup = () => (
  <div>
    <h1>Verification Page Setup</h1>
    <p>Code snippet for your verification web page</p>
  </div>
);

const App = () => (
  <ThemeProvider theme={lightTheme}>
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      loginPage={props => <CustomLoginPage {...props} theme={lightTheme} />}
      layout={Layout}
      dashboard={Dashboard}
      theme={ lightTheme}  // Pass theme directly to Admin
      darkTheme={darkTheme}                      // Optional: for theme toggle
      lightTheme={lightTheme}    
      // Fixing layout horis scrolling issue
      sx={{
        '& .RaLayout-root': {
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
        },
        '& .RaLayout-content': {
            padding: 0,
            overflow: 'hidden',
        }
    }}
    >
  
    {/* <Resource name="provisioning" options={{ label: 'Tag Provisioning' }} icon={SettingsIcon} list={TagList} /> */}

    <Resource
        name="provenance"
        options={{ label: 'Product Provenance' }}
        icon={SourceIcon}
        list={ProvenanceList}
        edit={ProvenanceEdit}
        create={ProvenanceCreate}
        show={ProvenanceShow}
      />
    <CustomRoutes>
      <Route path="/provenance/:id/upload" element={<ProvenanceUpload />} />
    </CustomRoutes>

    <Resource 
      name="verifications" 
      options={{ label: 'Verifications' }}  
      icon={VerifiedUserIcon} 
      list={VerificationsList}
      show={VerificationShow}
    />

    {/* <Resource name="consumers" options={{ label: 'Consumers' }}  icon={PeopleIcon} list={ConsumerList} /> */}
    <Resource name="marketing" options={{ label: 'Campaigns' }}  icon={CampaignIcon} list={MarketingRouter} />
    <Resource name="nft" options={{ label: 'NFTs' }}  icon={TokenIcon} list={NFTList} />
    {/* <Resource name="integrations" options={{ label: 'Integrations' }}  icon={IntegrationInstructionsIcon} list={IntegrationList} create={IntegrationCreate} /> */}

    <Resource name="privacy-policy" list={PrivacyPolicy} options={{ label: null }}  />
<Resource name="terms-of-service" list={TermsOfService} options={{ label: null }}  />
<Resource name="cookie-settings" list={CookieSettings} options={{ label: null }}  />
  </Admin></ThemeProvider>
);

export default App;